import React from "react";
import {Box, Button} from '@mui/material';
const View = ({onBtnClick}: {onBtnClick: Function}) => (
   <Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <Button variant="contained" onClick={() => onBtnClick()}>Начать тест</Button>
   </Box>
);

export default View;